<div class="chat-container">
  <div class="form-group">
    <label for="">Instructions</label>
    <textarea [(ngModel)]="instruction" placeholder="Add a Instructions" class="form-control"></textarea>
  </div>
  <button class="mt-2 btn btn-primary w-100" [disabled]="isLoading" (click)="submit()">
    <i class="fa-solid fa-save"></i> Save
  </button>
</div>